<script>
import moment from "moment";
import {
  MapVisionDisease,
  MapTreatmentStage,
} from "@/common/util";
import forOwn from "lodash/forOwn";

import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer,
  },
  data() {
    const activePageNumber = sessionStorage.getItem("trainWeekFeedbackActivePage") || 1;
    let stationId = this.$cookie.get("stationId");
    let searchFormData = {
      name: undefined,
      phone: undefined,
      visionDisease: undefined,
      treatmentStage: undefined,
    };
    if (sessionStorage.getItem("trainWeekFeedbacksearchFormData")) {
      searchFormData = JSON.parse(
        sessionStorage.getItem("trainWeekFeedbacksearchFormData")
      );
    }
    let activeSerachArray = [
      {
        label: "姓名",
        keyName: "name",
        type: "text",
        value: searchFormData.name,
      },
      {
        label: "手机号",
        keyName: "phone",
        type: "text",
        value: searchFormData.phone,
      },
      {
        label: "类型",
        keyName: "visionDisease",
        type: "select",
        value: searchFormData.visionDisease || "",
        children: [
          { label: "全部", keyName: "" },
          { label: "弱视", keyName: "AMBLYOPIA" },
          { label: "斜视", keyName: "STRABISMUS" },
          { label: "其他", keyName: "OTHER" },
        ],
      },
      {
        label: "训练阶段",
        keyName: "treatmentStage",
        type: "select",
        value: searchFormData.treatmentStage || "",
        children: [
          { label: "全部", keyName: "" },
          { label: "提升期", keyName: "PROMOTE" },
          { label: "巩固期", keyName: "CONSOLIDATION" },
        ],
      },
    ];
    return {
      tableData: [],
      stationId,
      totalElements: 0,
      pageCount: 0,
      activePage: parseInt(activePageNumber),
      activeSerachArray,
      searchFormData,
      exporting: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const params = {
        sort: "createdAt,DESC",
        size: 10,
      };
      forOwn(this.searchFormData, (value, key) => {
        if (value !== undefined && value !== "" && value !== null) {
          params[key] = value;
        }
      });
      params.page = this.activePage - 1;
      sessionStorage.setItem(
        "trainWeekFeedbacksearchFormData",
        JSON.stringify(this.searchFormData)
      );
      const data = await this.$http.getTrainWeeklyFeedback(params, this.stationId);
      if (data && data.content) {
        let newTableData = [];
        this.pageCount = data.totalPages;
        this.totalElements = data.totalElements;
        data.content.forEach((item) => {
          const analysisStart = item.analysisStart
            ? moment(item.analysisStart)
            : null;
          const analysisEnd = item.analysisEnd
            ? moment(item.analysisEnd).subtract(1, "days")
            : null;
          const analysisRange =
            analysisStart && analysisEnd
              ? `${analysisStart.format("M月D日")} ~ ${analysisEnd.format("M月D日")}`
              : "--";
          newTableData.push({
            userName: item.userName || "--",
            visionDisease: MapVisionDisease(item.visionDisease),
            treatmentStage: MapTreatmentStage(item.treatmentStage),
            createdAt: item.createdAt
              ? moment(item.createdAt).format("YYYY-MM-DD")
              : "--",
            analysisRange,
            expectedCount: item.expectedCount != null ? item.expectedCount : 0,
            actualCount: item.actualCount != null ? item.actualCount : 0,
            completionRate:
              item.completionRate != null ? `${item.completionRate}%` : "0%",
            remainingCount:
              item.remainingCount != null ? item.remainingCount : 0,
          });
        });
        this.tableData = newTableData;
      }
    },
    onSearch(done) {
      this.activePage = 1;
      sessionStorage.setItem("trainWeekFeedbackActivePage", 1);
      forOwn(done, (value, key) => {
        this.searchFormData[key] = done[key];
      });
      this.loadData();
    },
    async onExport() {
      if (this.exporting) {
        return;
      }
      if (this.totalElements > 3000) {
        this.$message.warning("导出的数据过多，请调整导出条件！");
        return;
      }
      this.exporting = true;
      const params = {
        sort: "createdAt,DESC",
      };
      forOwn(this.searchFormData, (value, key) => {
        if (value !== undefined && value !== "" && value !== null) {
          params[key] = value;
        }
      });
      const result = await this.$http.exportTrainWeeklyFeedback(
        params,
        this.stationId
      );
      if (result) {
        const link = document.createElement("a");
        const blob = new Blob([result], {
          type: "application/vnd.ms-excel",
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "训练周反馈.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      this.exporting = false;
    },
    onSearchChange(data) {
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    handleCurrentChange(val) {
      this.activePage = val;
      sessionStorage.setItem("trainWeekFeedbackActivePage", val);
      this.loadData();
    },
  },
};
</script>
<template>
  <div class="trainWeekFeedbackIndex">
    <searchFormNew
      class="searchFormNew"
      showSearch
      @onSearch="onSearch"
      :searchItemArray="activeSerachArray"
    />
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{ totalElements }}</span> 个
      <el-button
        class="exportButton"
        type="primary"
        size="small"
        :loading="exporting"
        @click="onExport"
        >导出</el-button
      >
    </div>
    <el-table
      :data="tableData"
      class="accountTable"
      :header-cell-style="{
        'padding-left': '4px',
        color: 'rgba(0,0,0,0.65)',
        'font-size': '14px',
        'background-color': '#fafafa !important',
      }"
      :cell-style="{ 'padding-left': '4px' }"
    >
      <el-table-column
        prop="userName"
        align="left"
        label="用户姓名"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="visionDisease"
        align="left"
        label="类型"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="treatmentStage"
        align="left"
        label="训练阶段"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        align="left"
        label="开通日期"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="analysisRange"
        align="left"
        label="分析日期"
        min-width="160"
      ></el-table-column>
      <el-table-column
        prop="expectedCount"
        align="left"
        label="应该训练次数"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="actualCount"
        align="left"
        label="实际训练次数"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="completionRate"
        align="left"
        label="完成率"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="remainingCount"
        align="left"
        label="剩余次数"
        width="100"
      ></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainWeekFeedbackIndex {
  .searchFormNew {
    border: 1px;
    height: 50px;
    margin: 0 2%;
    padding-top: 10px;
  }
  .statistics {
    margin: 0 2%;
    padding-bottom: 10px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    .totalResult {
      color: #00c1de;
    }
    .exportButton {
      float: right;
    }
  }
  .accountTable {
    margin: 0 2%;
    width: 96%;
  }
  .PagenationContainer {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/trainWeekFeedback/index.vue